/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeMainGuardianDto } from '../../models/change-main-guardian-dto';
import { GuardianDto } from '../../models/guardian-dto';

export interface ParentGuardianControllerChangeMainGuardianByParent$Params {
      body: ChangeMainGuardianDto
}

export function parentGuardianControllerChangeMainGuardianByParent(http: HttpClient, rootUrl: string, params: ParentGuardianControllerChangeMainGuardianByParent$Params, context?: HttpContext): Observable<StrictHttpResponse<GuardianDto>> {
  const rb = new RequestBuilder(rootUrl, parentGuardianControllerChangeMainGuardianByParent.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GuardianDto>;
    })
  );
}

parentGuardianControllerChangeMainGuardianByParent.PATH = '/api/guardian/parent/main-guardian';
